import { TablasComponent } from './components/tablas/tablas.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TableroComponent } from './tablero.component';

const routes: Routes = [{
  path: '',
  component: TablasComponent
  /*children: [
    {
      path: 'tablero',
      component: TablasComponent
    }
  ]*/
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TableroRoutingModule { }
